import * as Yup from "yup";
import UserSignUpValidation from "./userSignUp.validation";
const PhysicianSignUpValidation = Yup.object()
  .concat(UserSignUpValidation)
  .shape({
    suffix: Yup.string()
      .required("Suffix is required!")
      .test(
        "no-empty-blank-space",
        "Suffix cannot be an empty blank space(s)",
        (value: any) => {
          return value && value.trim() !== "";
        }
      ),
    specialty: Yup.string()
      .required("Speciality is required!")
      .test(
        "no-empty-blank-space",
        "Speciality cannot be an empty blank space(s)",
        (value: any) => {
          return value && value.trim() !== "";
        }
      ),
    npi: Yup.string()
      .matches(/^[0-9]{10}$/, "NPI must be a 10-digit number")
      .required("NPI is required!"),
  });

export default PhysicianSignUpValidation;
